import React from 'react'
import ReportDetailSubPage from "./ReportDetailSubPage"

function ReportDetailSubContainer() {
    return (
        <div className="ReportByDayContainer">
            <ReportDetailSubPage/>
        </div>
    )
}

export default ReportDetailSubContainer
